'use client';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { cn } from '@/lib/utils';
import { CircleAlert } from 'lucide-react';
import { ReactNode } from 'react';

type LoginError = {
    isShow?: boolean;
    title: string;
    desc?: ReactNode;
};

export const RenderAlertLogin = ({
    isShow = false,
    title,
    desc,
}: LoginError) => {
    return (
        <Alert
            className={cn('my-5 bg-red-50', {
                'invisible my-0 py-2': !isShow,
            })}
            variant='destructive'
        >
            {isShow && (
                <>
                    <CircleAlert className='h-5 w-5' />
                    <AlertTitle
                        className={cn('text-sm font-semibold', {
                            'mb-0': !desc,
                        })}
                    >
                        {title}
                    </AlertTitle>
                    {desc && (
                        <AlertDescription className='break-all text-xs font-medium'>
                            {desc}
                        </AlertDescription>
                    )}
                </>
            )}
        </Alert>
    );
};
